import React, { Component } from 'react';

import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import Clang from '../../containers/Clang';

const styles = theme => ({
  clang: {
    paddingTop: "16vh"
  },
  
  errorMsg: {
    color: 'white'
  },
  
  header: {
    fontSize: '1.5em',
    color: "white"
  },
  
  input: {
    marginTop:"20px",
    width:"300px",
    maxWidth:'70%',
    backgroundColor: theme.palette.common.white,
    borderRadius: 25,
    boxShadow: '',
    paddingLeft: '20px',
    paddingRight: '20px',
    '& label': {
      paddingTop: '4px',
      paddingLeft:'26px'
    },
  },
  
  loginBtn: {
    marginTop:'20px',
    width: '150px'
  },
  
  loginSection: {
    paddingTop: '0vh'
  },
  
  logo: {
    paddingTop: "48px",
    width: "200px"
  },
  
  root: {
    backgroundImage: `url("images/login_pig_background.png")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    maxWidth: "99%",
    minHeight: '98vh'
  },

  version: {
    paddingTop: "5px",
    fontSize: '0.72em',
    color: "#aaa"
  },

  '@media (max-width: 750px)': { //Iphones 6,7,8
  // '@media (max-width: 375px)': {
      clang: {
        marginLeft: "10px",
        paddingTop: "5vh"
      },
      loginBtn: {
        marginTop:'4px',
        width: '150px'
      },
      loginSection: {
        paddingTop: '0vh'
      },
      logo: {
        paddingTop: "24px",
        width: "150px"
      },
      root: {
        backgroundImage: `url("images/login_pig_background.png")`,
        backgroundRepeat: 'no-repeat',
        width: "110%",
        height: "100vh"
      }    
    },
    '@media (min-width: 751px) and (max-width: 1080px)': { //Iphones 6,7,8 plus
    // '@media (min-width: 376px) and (max-width: 414px)': {
      clang: {
        paddingTop: "16px"
      },
      loginBtn: {
        marginTop:'4px',
        width: '150px'
      },
      loginSection: {
        paddingTop: '0vh'
      },
      logo: {
        paddingTop: "32px",
        width: "200px"
      },
      root: {
        backgroundImage: `url("images/login_pig_background.png")`,
        backgroundRepeat: 'no-repeat',
        width: "100%",
        height: "100vh"
      }    
    }  
});

class Login extends Component{
    constructor(props){
       super(props);

        this._handleLogin = this._handleLogin.bind(this);
      
        this.state = {};
        this.state.user = props.user;
        this.state.pswd = props.pswd;
    }    
    
    _handleLogin(){
      this.props.handleLogin({
          user: this.state.user,
          pswd: this.state.pswd
      });
    }
 
    render(){
      const { classes } = this.props;

      return (
          <div className={classes.root}>
              <div className={classes.version}>{this.props.version}</div>
              <img className={classes.logo} src="images/logo.svg" alt="logo"></img>
              <div className={classes.clang}>
                <Clang ></Clang>
              </div>
              <div className={classes.loginSection}>
                <TextField className={classes.input}
                  label={this.props.texts.txt_user} 
                  value={this.state.user}
                  variant="standard"
                  onChange={(e) => this.setState({user: e.target.value})}
                />
                <br/>
                <TextField type="password" className={classes.input}
                  label={this.props.texts.txt_pswd} 
                  value={this.state.pswd}
                  variant="standard"
                  onChange={(e) => this.setState({pswd: e.target.value})}
                />
                <br/>
                {
                  this.props.loginState === 3 &&
                  <div className={classes.errorMsg}>
                    { this.props.texts.txt_user_pass_invalid }
                  </div>
                }
                <br/>
                <Fab variant="extended"
                  className={classes.loginBtn} 
                  color="primary"
                  onClick={this._handleLogin}>
                  {this.props.texts.txt_start}
                </Fab>
                <br/>
              </div>
          </div>
      );      
    }
}

export default withStyles(styles)(Login);


// WEBPACK FOOTER //
// ./src/components/Login/index.js